import {
  type CommunitySlim,
  type ContentObjectDetail,
  type ContentObjectList,
  type Profile,
  isCommunityContentObject,
} from 'models';
import { isCommunityOrOrganizationAdmin, isSuperAdmin } from './utils';

const getPostInCommunity = (contentObject: ContentObjectDetail | ContentObjectList): CommunitySlim | undefined =>
  contentObject.contentableType === 'Community' ? contentObject.postInCommunities[0] : undefined;

const isCommunityPublic = (contentObject: ContentObjectDetail | ContentObjectList) =>
  getPostInCommunity(contentObject)?.privacy === 'public';

const isCommunitySecret = (contentObject: ContentObjectDetail | ContentObjectList) =>
  getPostInCommunity(contentObject)?.privacy === 'secret';

const canAdminRepostInPrivateCommunity = ({
  contentObject,
  viewer,
}: {
  contentObject: ContentObjectDetail | ContentObjectList;
  viewer: Profile;
}) => {
  const community = getPostInCommunity(contentObject);

  if (community?.privacy !== 'private') {
    return false;
  }

  return isSuperAdmin({ viewer }) || isCommunityOrOrganizationAdmin({ community, viewer });
};

export const canRepostContentObject = ({
  contentObject,
  viewer,
}: {
  contentObject: ContentObjectDetail | ContentObjectList;
  viewer: Profile;
}) => {
  if (isCommunityContentObject({ contentObject })) {
    if (isCommunitySecret(contentObject)) {
      return false;
    }

    return isCommunityPublic(contentObject) || canAdminRepostInPrivateCommunity({ contentObject, viewer });
  }

  return false;
};
